var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconMedalMulticolor = function IconMedalMulticolor(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.153 51.034L38.193 64l7.394-8.274 11.093-.348-12.356-26.503-13.57-15.326 1.4 37.485z",
    fill: "#F71414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.986 28.882L7.619 55.378l11.091.349 7.396 8.271 15.822-33.83-21.942-1.286z",
    fill: "#9B021B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.83 31.812c.134.077.269.15.406.224.327.172.659.33.997.479.185.084.373.164.562.241.291.116.584.223.88.323.245.084.492.163.744.236.26.074.52.139.784.202.278.066.557.131.842.182.272.05.547.09.822.126.263.035.524.072.79.097.352.031.706.043 1.059.052.19.005.38.016.57.016.465-.004.93-.03 1.394-.072.084-.007.17-.009.254-.017a16.963 16.963 0 0011.319-6.075l.016-.018a16.932 16.932 0 003.879-10.81c0-1.758-.267-3.456-.762-5.05C46.229 5.034 39.765 0 32.15 0c-.087 0-.17.012-.256.012-7.21.109-13.33 4.724-15.694 11.15a16.961 16.961 0 00-1.05 5.836c0 .746.059 1.478.152 2.198.014.107.031.216.047.323a16.839 16.839 0 002.197 6.171l.007.016a17.11 17.11 0 006.276 6.106z",
    fill: "#FFB500"
  }));
};

IconMedalMulticolor.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconMedalMulticolor;
//# sourceMappingURL=IconMedalMulticolor.js.map